import { ReactElement } from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import logoSrc from 'domains/counterparties/assets/logo.png';
import {
  SContainer,
  SLogo,
  STitle2,
  SProperties,
  SProperty,
  SLabel,
  SValueSpacer,
  SText,
} from './Header.style';

export const HeaderComponent = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <SContainer>
      <div
        style={{
          display: 'flex',
        }}
      >
        <div>
          <Space size={16}>
            <SLogo>
              <img alt={String(t('accountManagement.header.counterparty.logo.altText'))} src={logoSrc} />
            </SLogo>
            <STitle2>DCM</STitle2>
          </Space>
        </div>

        <SProperties>
          <SProperty
            style={{
              width: 185,
            }}
          >
            <SLabel>{t('accountManagement.header.reserveAcc')}</SLabel>
            <SValueSpacer>
              <SText>500 000</SText>
            </SValueSpacer>
          </SProperty>
          <SProperty
            style={{
              width: 189,
            }}
          >
            <SLabel>{t('accountManagement.header.emissionAcc')}</SLabel>
            <SValueSpacer>
              <SText>329 124</SText>
            </SValueSpacer>
          </SProperty>
          <SProperty
            style={{
              width: 185,
            }}
          >
            <SLabel>{t('accountManagement.header.processingAcc')}</SLabel>
            <SValueSpacer>
              <SText>329 124</SText>
            </SValueSpacer>
          </SProperty>
          <SProperty
            style={{
              width: 185,
            }}
          >
            <SLabel>{t('accountManagement.header.totalAmount')}</SLabel>
            <SValueSpacer>
              <SText>210 921</SText>
            </SValueSpacer>
          </SProperty>
        </SProperties>
      </div>

      <div>
        <Button icon={<SettingOutlined />} />
      </div>
    </SContainer>
  );
};
